<template>
  <ol class="relative space-y-4 border-l border-gray-200">
    <li v-for="(item, index) in items" :key="item.id" class="ml-4">
      <div
        :class="[
          'absolute -left-1.5 mt-1.5 h-3 w-3 rounded-full border border-white',
          index === 0 ? 'bg-blue-600' : 'bg-gray-200',
        ]"
      />
      <time class="mb-1 text-xs font-normal leading-none text-gray-400">
        {{ item.time | formatDate }}
      </time>
      <p class="mb-1 text-sm font-medium text-gray-900">
        {{ item.name }}
      </p>
      <p v-if="item.text" class="text-xs font-normal text-gray-500">
        {{ item.text }}
      </p>
    </li>
  </ol>
</template>

<script>
export default {
  props: {
    items: {
      type: Array,
      required: true,
    },
  },
};
</script>
